import classes from './Coachmark.module.css.mjs';

const coachmarkSizeClassNames = {
  big: classes.coachmarkSizeBig,
  small: classes.coachmarkSizeSmall
};
const coachmarkWrapperClassNames = {
  default: classes.coachmarkWrapperDefault,
  highlight: classes.coachmarkWrapperHighlight
};

export { coachmarkSizeClassNames, coachmarkWrapperClassNames };
